'use client'

import Link from 'next/link'
import { capturePublicChatCrossSell } from './funnel-events'

export interface PublicChatCrossSell {
  label: string
  href: string
  target: 'shop'
}

/**
 * El cross-sell de la landing hacia la tienda del vídeo: pieza de cliente solo
 * para medir su clic (AC6.3) con el consentimiento del funnel. Lo que pasa por
 * el alta (también la videollamada) es un `SignupLink`.
 */
export function CrossSellLink({ crossSell, className }: { crossSell: PublicChatCrossSell; className: string }) {
  return (
    <Link href={crossSell.href} className={className} onClick={() => capturePublicChatCrossSell(crossSell.target)}>
      {crossSell.label}
    </Link>
  )
}
